export default __webpack_public_path__ + "static/media/iberian.acdc3156.jpg";